import TeaserData, { SEPARATOR_POSITIONS } from '@/services/builder/Teaser'

/**
 * data class for the inactivity dialog
 * @param dialogData the data retrieved from the backend
 */
export default class InactivityDialog {
  constructor (dialogData) {
    this.meta = dialogData.meta
    this.delay = dialogData.delay
    this.headline = dialogData.headline
    this.teasersHeadline = dialogData.teasersHeadline
    this.button = dialogData.button
    this.hideAlwaysText = dialogData.hideAlwaysText

    this.elements = dialogData.elements?.map((data) => {
      switch (data.type) {
        case 'teaser':
          return new TeaserData(data)
        case 'list':
          return {
            type: 'hp-list',
            elements: data.elements.map((listTeaser) => new TeaserData(listTeaser, { separator: SEPARATOR_POSITIONS.top }))
          }
        case 'ad':
          return {
            type: 'hp-ad',
            tagId: data.tagid,
            autoLoad: false
          }
        default:
          return data
      }
    }) || []
  }
}
